import { z } from 'zod';
import { accountFilterSchema, idArray } from './shared.schema';

export const paymentReconciliationReportFormatSchema = z.enum(['csv', 'pdf', 'xlsx']);

export const paymentReconciliationParametersSchema = z
	.strictObject({
		startDate: z.iso.date(),
		endDate: z.iso.date().optional(),
		accountFilter: accountFilterSchema.optional(),
		areaIds: idArray.optional(),
		branchIds: idArray.optional(),
		districtIds: idArray.optional(),
		facilityIds: z.array(z.string()).optional(),
		format: paymentReconciliationReportFormatSchema.default('csv'),
		facilityNumber: z.union([z.string(), z.number()]).optional(),
	})
	.superRefine((value, ctx) => {
		if (value.endDate && value.endDate < value.startDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['endDate'],
				message: 'End date must be on or after start date',
			});
		}
	});

export type PaymentReconciliationParameters = z.infer<typeof paymentReconciliationParametersSchema>;
export type PaymentReconciliationReportFormat = z.infer<typeof paymentReconciliationReportFormatSchema>;
